import {createEmpty, extend} from 'ol/extent';
import {map} from '../map/map';
import GeoJSON from 'ol/format/GeoJSON.js';

export default function(geojson, padding, zoom = 14) {
//	var pan = ol.animation.pan({duration: 500, source: map.getView().getCenter()})
//	var zoom = ol.animation.zoom({duration: 500, resolution: map.getView().getResolution()})
//	map.beforeRender(pan, zoom);
	
	var view = map.getView();
	//var zoom = 14;
	if(map.getView().getZoom() > 14) {
		zoom = map.getView().getZoom();
	}
	const duration = 500;
	
	var format = new GeoJSON();
  var features = format.readFeatures(geojson);
  console.log(features)
	

  let extent = new createEmpty();
	
  features.forEach((feature) => {
	  extent = new extend(extent, feature.getGeometry().getExtent());
  })
  view.fit(extent, {padding: padding, maxZoom: zoom, duration: duration});
  
	//const featureToFit = arrFeatures[0].getGeometry();

	//view.fit(featureToFit, {padding: padding, maxZoom: zoom, duration: duration});
	
	if(typeof callbackFunc != 'undefined')
		callbackFunc(feature);
}